/*Get QUESTION TYPES */
export const GET_QUESTIONTYPES = "GET_QUESTIONTYPES"
export const GET_QUESTIONTYPES_SUCCESS = "GET_QUESTIONTYPES_SUCCESS"
export const GET_QUESTIONTYPES_FAIL = "GET_QUESTIONTYPES_FAIL"

/*Get NNS NAMES */
export const GET_NNS = "GET_NNS"
export const GET_NNS_SUCCESS = "GET_NNS_SUCCESS"
export const GET_NNS_FAIL = "GET_NNS_FAIL"

/*Get NNS STRANDS */
export const GET_NNS_STRANDS = "GET_NNS_STRANDS"
export const GET_NNS_STRANDS_SUCCESS = "GET_NNS_STRANDS_SUCCESS"
export const GET_NNS_STRANDS_FAIL = "GET_NNS_STRANDS_FAIL"

/*Get AWARD PERIODS */
export const GET_AWARD_PERIODS = "GET_AWARD_PERIODS"
export const GET_AWARD_PERIODS_SUCCESS = "GET_AWARD_PERIODS_SUCCESS"
export const GET_AWARD_PERIODS_FAIL = "GET_AWARD_PERIODS_FAIL"

/*Get PROJECTS */
export const GET_PROJECTS = "GET_PROJECTS"
export const GET_PROJECTS_SUCCESS = "GET_PROJECTS_SUCCESS"
export const GET_PROJECTS_FAIL = "GET_PROJECTS_FAIL"

/**
 * Add PROJECT
 */
export const ADD_PROJECT = "ADD_PROJECT"
export const ADD_PROJECT_SUCCESS = "ADD_PROJECT_SUCCESS"
export const ADD_PROJECT_FAIL = "ADD_PROJECT_FAIL"

/**
 * Update PROJECT
 */
export const UPDATE_PROJECT = "UPDATE_PROJECT"
export const UPDATE_PROJECT_SUCCESS = "UPDATE_PROJECT_SUCCESS"
export const UPDATE_PROJECT_FAIL = "UPDATE_PROJECT_FAIL"

/*Get PROJECT DETAIL */
export const GET_PROJECT_DETAIL = "GET_PROJECT_DETAIL"
export const GET_PROJECT_DETAIL_SUCCESS = "GET_PROJECT_DETAIL_SUCCESS"
export const GET_PROJECT_DETAIL_FAIL = "GET_PROJECT_DETAIL_FAIL"

/*Get QUESTION DETAIL */
export const GET_QUESTION_DETAIL = "GET_QUESTION_DETAIL"
export const GET_QUESTION_DETAIL_SUCCESS = "GET_QUESTION_DETAIL_SUCCESS"
export const GET_QUESTION_DETAIL_FAIL = "GET_QUESTION_DETAIL_FAIL"

/*Add QUESTION RESPONSE */
export const ADD_QUESTION_RESPONSE = "ADD_QUESTION_RESPONSE"
export const ADD_QUESTION_RESPONSE_SUCCESS = "ADD_QUESTION_RESPONSE_SUCCESS"
export const ADD_QUESTION_RESPONSE_FAIL = "ADD_QUESTION_RESPONSE_FAIL"

/*Get RESPONSE OUTCOME */
export const GET_RESPONSE_OUTCOME = "GET_RESPONSE_OUTCOME"
export const GET_RESPONSE_OUTCOME_SUCCESS = "GET_RESPONSE_OUTCOME_SUCCESS"
export const GET_RESPONSE_OUTCOME_FAIL = "GET_RESPONSE_OUTCOME_FAIL"

/*Clear State*/
export const CLEAR_QUESTIONNNAIRE_STATE = "CLEAR_QUESTIONNNAIRE_STATE"
